// Shared plumbing for the authenticated mKonnekt routes on the Node backend.
//
// Every route under Mkonnekt_discount/* except the public get_discounts requires the admin-panel
// session twice: `Authorization: Bearer <token>` header AND body `merchant_id`, `token_id`,
// `login_type` (Node middleware/authenticateToken.js).

import Config from "../../Constants/Config";
import { getAuthDetails } from "../../Common/cookiesHelper";

export const NODE_BASE = Config.BASE_NODE_URL
  ? Config.BASE_NODE_URL.endsWith("/")
    ? Config.BASE_NODE_URL
    : Config.BASE_NODE_URL + "/"
  : "";

/** The session credentials the Node auth gate reads. Blank strings when there is no session. */
export function authFields() {
  const a = getAuthDetails();
  const rec = a?.LoginGetDashBoardRecordJson;
  const utd = a?.userTypeData || {};
  return {
    token: rec?.token || "",
    token_id: utd.token_id || "",
    login_type: utd.login_type || "",
  };
}

/** Request headers for an authenticated JSON call. */
export function authHeaders(token) {
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
